import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.tr<ContainerProps>`
  width: 100%;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease;

  &:hover {
    background: rgba(255, 211, 54, 0.1) !important;
  }

  &:nth-child(odd) {
    background: rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 1024px) {
    width: 300%;
  }

  &:last-child {
    border-bottom: none;
  }

  &:last-child > div:first-child {
  }

  &:last-child > div:last-child {
  }

  &:hover td {
    background: rgba(255, 211, 54, 0.1) !important;
  }
`;
